<script setup>

import {ref} from 'vue';
import AppLayout from "@/Layouts/AppLayout.vue";
import InputLabel from "@/Components/InputLabel.vue";
import TextInput from "@/Components/TextInput.vue";
import {Inertia} from "@inertiajs/inertia";
import PaginationLinks from "@/Components/PaginationLinks.vue";

const props = defineProps({
  companies: Object,
  pageSearchQuery: '',
});
const searchQuery = ref(props.pageSearchQuery);
const searching = ref(false);

const makeSearchRequest = _.debounce(() => {
  searching.value = true;
  const queryParameters = route().params || {};
  if (queryParameters.page) {
    delete queryParameters.page;
  }
  queryParameters['query'] = searchQuery.value;
  Inertia.get(route(route().current(), queryParameters), {}, {preserveScroll: true});
  searching.value = false;
}, 400);
</script>

<template>
  <AppLayout title="Companies">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Companies
      </h2>
    </template>

    <div class="mx-auto py-10 sm:px-6 lg:px-8">
      <div class="mt-5 mb-2 md:grid md:grid-cols-2 grid-cols-1">
        <div>
          <InputLabel for="search" value="Search" class="inline mr-2"/>
          <TextInput
            id="search"
            v-model="searchQuery"
            type="text"
            class="mt-1 inline"
            placeholder="John Doe"
            @keyup="makeSearchRequest"
            :disabled="searching"
          />
        </div>
      </div>

      <table class="min-w-full w-full text-left text-sm font-light">
        <thead class="border-b font-medium dark:border-neutral-500">
        <tr>
          <th scope="col" class="px-4 py-2">Company Name</th>
          <th scope="col" class="px-4 py-2">Email</th>
          <th scope="col" class="px-4 py-2 hidden md:table-cell">Phone Number</th>
          <th scope="col" class="px-4 py-2">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr
          class="border-b transition duration-300 ease-in-out hover:bg-neutral-200"
          v-for="company in companies.data">
          <td class="px-4 py-2 break-words" v-text="company.client"></td>
          <td class="px-4 py-2 break-words" v-text="company.email"></td>
          <td class="px-4 py-2 break-words hidden md:table-cell" v-text="company.phone"></td>
          <td>
            <a :href="route('production.companies.show', {company: company.ID})" class="fa fa-eye mr-1 p-1"
               :title="`View ${company.client}`">
            </a>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="text-center mt-5">
        <PaginationLinks :pagination="companies"/>
      </div>
    </div>

  </AppLayout>
</template>
